import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import "./homeHallPolish.css";
import "./todayFinancePolish.css";
import "./paletteV2.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("V2_ROOT_MISSING");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
